import { render } from "./edit.vue?vue&type=template&id=6371459c&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=6371459c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6371459c"

export default script